import { useMemo } from 'react'
import { useDataFormat, useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let selectedOption = useDataFormat({
    context: 'appointment_overlay',
    path: 'appointment_id',
    viewPath: props.viewPath,
    format: value => (value === 'new' ? 'new' : 'existing'),
  })
  let appointments = useDataFormat({
    context: 'appointments',
    viewPath: props.viewPath,
    format: value => value.filter(item => item.id !== 'new'),
  })
  let isEmergency = useDataValue({
    context: 'appointment_overlay',
    path: 'is_emergency',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    return data.map(item => ({
      ...item,
      isSelected: item.id === selectedOption,
      isDisabled:
        item.id === 'existing' && (!appointments.length || isEmergency),
    }))
  }, [data, selectedOption, appointments, isEmergency])
}
